exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list {\r\n    width: auto;\r\n    max-height: 150px;\r\n    display: inline-block;\r\n    position: relative;\r\n    text-align: left;\r\n    overflow: auto\r\n}\r\n\r\n    .list li {\r\n        padding: 4px 0;\r\n        float: left;\r\n        width: 100%;\r\n    }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/uw-reshuffle-dialog/uw-reshuffle-dialog.component.css
// module id = ../../../../../src/app/uw-reshuffle-dialog/uw-reshuffle-dialog.component.css
// module chunks = main